module.exports = __webpack_public_path__ + "static/img/lijun.074b06a1.png";